import styled from "styled-components";
export const LogoWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const LogoImage = styled.img `
  width: 125px;
  height: auto;
  border-radius: 5px;
`;
